export default "__VITE_ASSET__f1748d5c__"